"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckAllHeader = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var CheckAllHeader = function (props) {
    return (react_1.default.createElement(storm_ui_1.Checkbox, __assign({ id: (0, storm_ui_1.useUID)('check-all-header-checkbox'), disabled: props.rows.length === 0 && !props.hasRefinementsSet, label: '' }, props.getToggleAllRowsSelectedProps())));
};
exports.CheckAllHeader = CheckAllHeader;
